import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import stationary from "../../../../../assets/images/OUR SERVICES/8.Stationary.png";
import EnquiryModal from '../../../../../common/pages/enquiryModal';
const Stationary = () => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);
    return (
        <React.Fragment>

            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Office Stationary</h2>

                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">
                                <Col lg={6} md={12} className="text-center">
                                    <img
                                        src={stationary}
                                        alt="Office Stationery"
                                        className="img-fluid rounded"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12}>
                                    <h2 className="fw-bold " style={{ color: "rgb(52, 81, 159)" }}>Office Stationary</h2>
                                    <p className="text-black">
                                        Keep your workspace organized and efficient with our premium office stationery products.
                                        We provide a wide range of high-quality essentials for all your business needs.
                                    </p>
                                    <h5 className="fw-bold text-black">Available Products:</h5>
                                    <ul className="text-black">
                                        <li>Pens, Pencils, and Markers</li>
                                        <li>Notebooks and Diaries</li>
                                        <li>Files, Folders, and Binders</li>
                                        <li>Sticky Notes and Memo Pads</li>
                                        <li>Staplers, Punch Machines, and Clips</li>
                                        <li>Whiteboards and Markers</li>
                                        <li>Printing Paper and Envelopes</li>
                                    </ul>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
                <EnquiryModal isOpen={modal} toggle={toggleModal} />
            </section>
            <section className="section  py-5" style={{ backgroundColor: " rgb(52, 81, 159)" }} id="features">
                <Container>
                    <Row className="justify-content-center">
                        <div className='text-center '>
                            <Button className='px-4 py-2 fw-bold' onClick={toggleModal}
                                style={{ background: "rgb(238, 99, 82)", borderRadius: "20px", color: "white", fontSize: "20px" }}
                            >
                                Enquiry Now
                            </Button>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default Stationary;